/*
 * File: AuthenticateModal.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 20, 2025 at 9:44 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const ModalInner = styled.div`
	padding: 20px 20px 20px;

	p {
		margin: 5px 0px 0px;
		color: ${({ theme }) => theme.secondaryText};
	}
	button {
		margin: 30px 0 0px;
		width: 100%;
	}
`;

export const InputContainer = styled.div`
	margin: 30px 0px 40px;
`;

export const Form = styled.form`
	& > div {
		margin-bottom: 10px;
	}
	textarea {
		padding: 0px !important;
		font-size: 1.4rem;
		font-weight: 400;
	}
`;
